import { NgModule } from '@angular/core';
import { TPipe } from './t.pipe';
import { PricePipe } from './price.pipe';

const PIPES = [TPipe, PricePipe];

@NgModule({
  declarations: [...PIPES],
  exports: [...PIPES],
})
export class PipeModule {}
